import { get } from 'lodash';
import ModelsIcon from '@/Theme/icons/modelsIcon';
import * as outlineIcons from '@heroicons/react/24/outline';
import * as solidIcons from '@heroicons/react/24/solid';
import { icons as modelIcons } from '@/Theme/icons/modelsIcons/index';

export const defaultMenuOptionsProps = {
  classNameContainer: 'w-fit',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  sx: {},
  PaperProps: {
    sx: {
      px: 1,
      mt: 1,
      minWidth: 200,
      maxHeight: '400px',
      borderRadius: '12px',
      backgroundColor: (theme) =>
        theme.palette.mode === 'dark' ? '#5C5A5E' : '#EDEDF2',
      '& .MuiMenuItem-root': {
        py: 1,
        px: 2,
        mb: 1,
        maxWidth: '350px',
        borderRadius: '12px',
        '&:hover': {
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? '#51526C' : '#D4D5E6',
          color: (theme) =>
            theme.palette.mode === 'dark' ? '#ADB1FF' : '#5256A6',
        },
        '&.Mui-selected': {
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? '#51526C' : '#D4D5E6',
          color: (theme) =>
            theme.palette.mode === 'dark' ? '#ADB1FF' : '#5256A6',
        },
      },
      '&::-webkit-scrollbar': {
        width: '8px',
        paddingTop: '20px',
        paddingBottom: '20px',
      },
      '&::-webkit-scrollbar-track': {
        my: 1,
        borderRadius: '10px',
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '10px',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? '#51526C' : '#D4D5E6',
        '&:hover': {
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? '#464BBA' : '#5256A6',
        },
      },
    },
  },
};

export const MODEL_TYPES = {
  image: 'image',
  video: 'video',
  audio: 'audio',
  browser: 'browser',
  reasoning: 'reasoning',
};

export const renderIcon = (iconName, variant = 'outline') => {
  const icons = variant === 'outline' ? outlineIcons : solidIcons;
  const Icon = get(icons, iconName + 'Icon');

  if (!Icon) {
    console.log(`Icon "${iconName}" not found in Heroicons ${variant} set`);
    return null;
  }

  return Icon;
};

export const getIconModelSelector = (model, color, size) => {
  const Icon = get(modelIcons, model.icon);
  return Icon ? (
    <Icon
      className={`size-${size}`}
      fillColor={model.color || '#464BBA'}
      color={color}
    />
  ) : (
    <ModelsIcon className={`size-${size} stroke-white`} />
  );
};
